import { useEffect, useState } from "react";
import { getLedgerByCustomer } from "src/shared/services/servicesv2";

export function useLedger(customerId?: string) {
  const [outstandingBalance, setOutstandingBalance] = useState<number | string>(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!customerId) return;

    const fetchLedger = async () => {
      setLoading(true);
      try {
        const res = await getLedgerByCustomer(customerId);
        const ledger = res.data.ledger;

        if (Array.isArray(ledger)) {
          const first = ledger[0] || {};
          const balance = first.totalOutstandingBalance ?? first.total_outstanding_balance ?? 0;
          setOutstandingBalance(balance);
        } else {
          const balance =
            ledger?.totalOutstandingBalance ??
            ledger?.total_outstanding_balance ??
            res.data?.total_outstanding_balance ??
            res.data?.totalOutstandingBalance ??
            0;
          setOutstandingBalance(balance);
        }
      } catch (error) {
        console.error("Error fetching ledger:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchLedger();
  }, [customerId]);

  return { outstandingBalance, loading };
}
